

const NavBar = ({ title}) => {
  return (
    <div >
<h1>hii dashboard</h1>
    </div>
  );
};

export default NavBar;
